import { inject, Injectable } from '@angular/core';
import { MarginExpensesStore } from '../margin-expenses/margin-expenses.store';
import { MarginExpenseType } from '../../models/margin-expense-type.model';
import { tapResponse } from '@ngrx/operators';
import { take } from 'rxjs/operators';
import { MarginExpensesService } from '../../services/margin-expenses.service';

@Injectable({ providedIn: 'root' })
export class MarginExpensesEffects {
    private readonly marginExpensesStore = inject(MarginExpensesStore);
    private readonly marginExpensesService = inject(MarginExpensesService);

    loadMarginExpenseTypes(): void {
        this.marginExpensesService
            .getMarginExpensesTypes()
            .pipe(
                take(1),
                tapResponse({
                    next: (data: MarginExpenseType[]) => {
                        this.marginExpensesStore.loadMarginExpenseTypes(data);
                    },
                    error: () => {
                        this.marginExpensesStore.loadMarginExpenseTypes([]);
                    }
                })
            )
            .subscribe();
    }
}
